import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
export const orgSupportContactSelectedEvent = EVENT_PAYLOAD;
export const orgPaymentPortalReturnedEvent = EVENT_PAYLOAD;
export const orgAuditLogSettingUpdateAttemptedEvent = (data) => ({
    event: 'org audit log setting update attempted',
    data,
});
// One event for all three permission toggles on the org Skills page; the `setting` key
// distinguishes them rather than three near-duplicate event names.
export const orgSkillsSettingToggledEvent = EVENT_PAYLOAD;
export const enterpriseMemoryEvent = EVENT_PAYLOAD;
export const orgVideoModelSettingToggledEvent = EVENT_PAYLOAD;
// One event for the CrowdStrike Falcon section on the org Computer page; it
// fires once per Save or toggle attempt with its outcome, never on keystrokes.
export const orgCrowdStrikeFalconSettingChangedEvent = EVENT_PAYLOAD;
export const orgConnectorMigrationEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map